import React from 'react';
import { INavigationItemInfo, NAV_ENABLE_STATUS } from '@umu/umu-api';
import { DragDropContext, DropResult, Droppable, Draggable, DraggingStyle, NotDraggingStyle } from 'react-beautiful-dnd';
import { Table } from '@umu/umu-design';
import { classSet } from '@umu/umu-dom';
import { Loading } from 'common/src/components';
import ListBlankPC from '../../../ListBlank/ListBlankPC';
import { lang } from '@umu/ukit-lang';
/**
 * @desc 表格拖拽-默认行数据
 */
const defaultTrProps = {
    record: {
        id: 'nodata',
        is_enabled: NAV_ENABLE_STATUS.DISABLE,
    },
    index: 0,
};
/**
 * @desc 表格拖拽时其他行数据-样式
 */
const getListStyle = (_isDraggingOver: boolean): {} => {
    return {};
};
/**
 * @desc 表格当前拖拽行-样式
 */
const getItemStyle = (draggableStyle?: DraggingStyle | NotDraggingStyle, _isDragging?: boolean): {} => {
    return {
        ...draggableStyle,
    };
};
interface IProps {
    className?: string;
    isLoading?: boolean;
    list: INavigationItemInfo[];
    columns: any[];
    onUpdateListBySort: (sourceIndex: number, destinationIndex: number) => void;
}
const DragNavigationTable = (props: IProps) => {
    const { list, columns, className = '', isLoading, onUpdateListBySort } = props;
    const onDragEnd = (result: DropResult) => {
        if (!result.destination) {
            return;
        }
        onUpdateListBySort(result.source.index, result.destination.index);
    };
    const BodyRow = (item: any) => {
        const { children, ...rest } = item;
        const { record, index = 0 } = (children[0] || {})?.props || defaultTrProps;
        const { id, is_enabled } = record;
        return (
            <Draggable
                key={id}
                draggableId={id}
                index={index}
                isDragDisabled={is_enabled === NAV_ENABLE_STATUS.DISABLE}
            >
                {(provided, draggableProvided) => {
                    const { isDragging } = draggableProvided;
                    return (
                        <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            {...rest}
                            className={isDragging ? 'table-tr-dragging' : ''}
                            style={getItemStyle(provided.draggableProps.style, isDragging)}
                        >
                            {children}
                        </tr>
                    );
                }}
            </Draggable>
        );
    };
    const BodyWrapper = (props: any) => {
        return (
            <Droppable droppableId="drag-id-body">
                {(provided, snapshot) => {
                    return (
                        <tbody
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            className={classSet({
                                'drag-context': true,
                            })}
                            {...props}
                            style={getListStyle(snapshot.isDraggingOver)}
                        ></tbody>
                    );
                }}
            </Droppable>
        );
    };
    const renderEmptyText = () => {
        return isLoading ? <Loading /> : <ListBlankPC type={2} title={lang('暂无数据')} />;
    };
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Table
                className={className}
                columns={columns}
                components={{
                    body: {
                        row: BodyRow,
                        wrapper: BodyWrapper,
                    },
                }}
                emptyText={renderEmptyText()}
                data={list}
            />
        </DragDropContext>
    );
};
export { DragNavigationTable };
